export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const FETCH_RESTRICTED_USERS = 'FETCH_RESTRICTED_USERS';
export const FETCH_USERS_RESTRICTED_SUCCESS = 'FETCH_USERS_RESTRICTED_SUCCESS';
export const FETCH_USERS_RESTRICTED_FAILURE = 'FETCH_USERS_RESTRICTED_FAILURE';

export const CLEAR_USERS_DATA = 'CLEAR_USERS_DATA';
